/**
 * Tooltip module
 */
import TooltipDirective from './directives/TooltipDirective';
import TooltipLabel from './tooltipLabel';
import 'tooltipster';

angular.module('edge.platform.widgets.tooltip', [])
    .directive('gwTooltip', TooltipDirective)
    .component('gwTooltipLabel', TooltipLabel);